import { Link } from "@tanstack/react-router";
import notFoundIllu from "@/assets/404-illustration.svg.asset.json";

export function NotFoundPage() {
  return (
    <main
      role="main"
      className="flex min-h-dvh items-center justify-center bg-background px-4 py-16"
    >
      <div className="mx-auto w-full max-w-xl text-center">
        <img
          src={notFoundIllu.url}
          alt=""
          aria-hidden="true"
          width={433}
          height={312}
          className="mx-auto mb-8 h-auto w-full max-w-[280px] md:max-w-[340px]"
        />
        <h1 className="heading-h1">Seite nicht gefunden</h1>
        <p className="mt-3 text-base text-muted-foreground">
          Die angefragte Seite existiert nicht oder wurde verschoben.
        </p>
        <div className="mt-8">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-md bg-brand-button px-5 py-3 text-sm font-semibold text-brand-button-foreground transition-opacity hover:opacity-90"
          >
            Zur Startseite
          </Link>
        </div>
        <p className="mt-6 text-sm text-muted-foreground">
          <a href="/sitemap.xml" className="underline underline-offset-4 hover:opacity-80">
            Seitenverzeichnis
          </a>
          {" · "}
          <Link to="/kontakt" className="underline underline-offset-4 hover:opacity-80">
            Kontakt
          </Link>
        </p>
      </div>
    </main>
  );
}
